<script setup lang="ts">
import type { IFileState } from "@/interfaces";
import ButtonEllipsis from "@/stories/buttons/ButtonEllipsis/ButtonEllipsis.vue";

interface Props {
  image?: IFileState;
  showRemoveButton?: boolean;
}

withDefaults(defineProps<Props>(), {
  showRemoveButton: true,
});

defineEmits<{ remove: [] }>();
</script>

<template>
  <div
    v-if="image"
    class="w-24 h-24 min-w-24 min-h-24 whitespace-nowrap object-cover overflow-hidden relative"
  >
    <img
      :src="image.url || image.base64"
      :alt="image.name"
      class="w-24 h-24 min-w-24 min-h-24 object-cover rounded"
    />
    <ButtonEllipsis
      v-if="showRemoveButton"
      class="absolute top-2 right-2 test-remove-button"
      @click="$emit('remove')"
    >
      <i class="far fa-trash-can"></i>
    </ButtonEllipsis>
  </div>
</template>
